import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import freddie from '../../images/mailchimp-freddie.jpg';
import logoglyph from '../../images/logos/nurelm-glyph-green.svg';
import { htmlDecode, mapTechCategories } from '../../helperFunctions';
import SectionLoader from '../../components/common/SectionLoader/SectionLoader';
import { useCaseStudies } from '../../util/queryFunctions';

export const MORE_OW_HEAD = 'MORE OF OUR WORK';
export const OW_CATEGORY_START = 'CATEGORY: ';


const MoreOfOurWork = ({ ourWorkItemId }) => {
  const { data, isFetching } = useCaseStudies(ourWorkItemId)

  const renderImage = (study) => {
    const src = get(study, 'acf.square_featured_image.sizes.medium', freddie);
    const alt = get(study, 'acf.square_featured_image.alt', false)
    
    return <img src={src} alt={alt} />;
  }

  const renderMoreCaseStudies = () => {
    if (isFetching) {
      return (
        <Col xs={12} sm={12} lg={12}>
          <SectionLoader />
        </Col>
      )
    }

    return data.slice(0, 3).map((study) => {
      return (
        <Col className="more-work-col" sm={12} md={4} lg={4} key={study.slug}>
          <Link
            to={`/our-work/${study.slug}`}
            onClick={() => window.scrollTo(0, 0)}
            title="Read this case study"
          >
            <div>
              {renderImage(study)}
            </div>
            <div className="more-work-copy">
              <h6>
                {OW_CATEGORY_START}
                {mapTechCategories(study)}
              </h6>
              <h5>
                {htmlDecode(study.title.rendered)}
              </h5>
              <p>
                {study.acf.hero_headline}
              </p>
            </div>
          </Link>
        </Col>
      );
    })
  }

  return (
    <div className="more-work">
      <Grid>
        <Row className="centered-work">
          <h3>{MORE_OW_HEAD}</h3>
        </Row>
        <Row className="more-work-row">
          {renderMoreCaseStudies()}
        </Row>
        <Row className="centered-work">
          <img src={logoglyph} alt="NuRelm logo icon" />
        </Row>
      </Grid>
    </div>
  );
};

export default MoreOfOurWork;
